import * as React from 'react';


import { useFormikContext } from 'formik';

import { useStepper } from '../../../context';
import { Icon } from '@eduzz/ui-antd-theme';

function BackButton() {
  const { prevStep, isFirst } = useStepper();
  const formik = useFormikContext();

  if (isFirst || formik?.status === 'submitted') return null;

  return (
    <button
      id='step-back-btn'
      className='text-content-subtitle mb-5.7 flex cursor-pointer items-center border-0 bg-transparent text-[[0.625rem] font-bold uppercase disabled:cursor-not-allowed disabled:opacity-70 [&:not(:disabled):hover>svg]:-translate-x-0.75'
      onClick={prevStep}
      disabled={formik?.isSubmitting}
    >
      <Icon.ArrowLeft className='text-primary mr-1.5 transition-transform duration-300'  />
      Voltar
    </button>
  );
}

export { BackButton };
